<script lang="ts">
    import { page } from '$app/stores';
    import LazyIcon from '$lib/components/LazyIcon/LazyIcon.svelte';
    import { createEventDispatcher } from 'svelte';
    import { toggleClasses } from '$lib/actions/toggleClasses';

    const dispatch = createEventDispatcher();
    const handleClose = () => dispatch('close');

    $: openAsDialog = Boolean($page.state.overlay);
</script>

<svelte:body use:toggleClasses={{ 'overflow-hidden': true }} />

<div
    class="fixed left-0 top-[var(--rg-height)] z-pageoverlay
        h-[calc(100%-var(--rg-height))] w-screen tablet:top-[var(--header-height)]
        tablet:h-[calc(100%-var(--header-height))]"
>
    <div class="relative h-full overflow-hidden">
        <div class="absolute h-full w-full bg-black/30 backdrop-blur-sm"></div>
        <div class="absolute h-full w-full">
            <div class="m-auto h-full w-screen tablet:w-[680px] tablet:pt-[36px]">
                {#if openAsDialog}
                    <div class="relative hidden tablet:block">
                        <div class="absolute right-0 translate-x-full">
                            <button
                                class="ml-md flex justify-center rounded-full bg-purple-80 p-md text-white"
                                on:click={handleClose}
                            >
                                <LazyIcon icon="close" class="h-md w-md" />
                            </button>
                        </div>
                    </div>
                {/if}

                <div
                    class="fixed h-[calc(100%-var(--body-height,0px))] w-full
                    overflow-hidden
                    [--body-height:calc(var(--bottom-bar-height)+var(--rg-height))]
                    tablet:static
                     tablet:h-full tablet:rounded-t-[32px] tablet:[--body-height:calc(var(--bottom-bar-height)+var(--header-height))]"
                >
                    <div class="h-full w-full overflow-auto">
                        <div class="h-full w-full">
                            <div class="h-full w-full overflow-y-auto overflow-x-hidden bg-grey-0">
                                <slot />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
